<template>
  <v-container>
    <v-text-field
      prefix="Nombre:"
      class="ml-3 mr-3"
      v-model="selectedItem.settings.component_name"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.settings.component_name == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />
    <p class="text-h6">Variables armario</p>
    <v-text-field
      prefix="Temperatura:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_temperature"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_temperature == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />
    <v-text-field
      prefix="Alarma:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_failure_alarm"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_failure_alarm == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "QLVNCabinetProperties",

  data() {
    return {};
  },
  computed: {
    ...mapState(["selectedItem"]),
  },

  methods: {
    ...mapActions(["updateEditing"]),
  },
};
</script>

<style></style>
